import "../../scss/app.scss";
import { getUrlParameter } from "../utils/Uri";

const hash = getUrlParameter("hash"),
  postal = getUrlParameter("postal");

window.location.replace(
  "https://general-frontend.inbooma.net?user=" +
    hash +
    (postal ? "&postal=true" : "") +
    "#/register-confirmation",
);
